import { ErrorIcon, Input } from '@pebl/ui';

import { CommonActionPropertyViewProps } from '../../../types';

export function ActionPropertyInputTextView({
  defaultValue,
  disabled,
  error,
  helperText,
  innerRef,
  label,
  name,
  onBlur,
  onChange,
  value,
}: {
  error?: boolean;
  label?: string;
  helperText?: string;
} & CommonActionPropertyViewProps<string>) {
  return (
    <Input
      type="text"
      label={label}
      error={error}
      name={name}
      value={value}
      defaultValue={defaultValue}
      disabled={disabled}
      onChange={(e) => onChange?.(e.target.value)}
      onBlur={onBlur}
      className="qng-action-property-input-text"
      helperText={helperText}
      helperTextIcon={<ErrorIcon outlined className="size-4" />}
      ref={innerRef}
      // Data Fields - Primarily for debugging / testing
      data-action-option-type="string"
      data-action-option-format="text"
    />
  );
}
